import { CSSProperties, ReactNode } from "react";
import styles from "./StatusTag.module.css";

export type StatusTagColor = "orange" | "red" | "green" | "blue" | "grey" | "yellow" | "blueLight" | "greyBlue" | "indigo" | "purple" | "pink";

type StatusTagProps = {
  text?: string;
  children?: ReactNode;
  color: StatusTagColor;
  className?: string;
  display?: string;
  borderRadius?: number;
  marginLeft?: number;
  marginRight?: number;
  marginTop?: number;
  marginBottom?: number;
};
/**
 * @deprecated use 'Badge' component instead
 */
export const StatusTag = ({
  text,
  color,
  className,
  display,
  marginBottom,
  marginTop,
  marginLeft,
  marginRight,
  children,
  borderRadius,
}: StatusTagProps) => {
  const style: CSSProperties = {
    display,
    marginLeft,
    marginRight,
    marginTop,
    marginBottom,
    borderRadius,
  };

  return (
    <span data-cy="status-tag-container" style={style} className={`${styles.container} ${styles[color]}${className ? ` ${className}` : ""}`}>
      {text ?? children}
    </span>
  );
};

